import { z } from 'zod/v4';
import { AmforiPhaseJobPayloadSchema } from './phase-job-payload.js';

/**
 * One in-scope audit a datapoints child batch must process. The parent resolves
 * these triples once (from its pre-filter) and passes them down, so the child
 * never re-queries: `monitoringId` scopes the amfori `?monitorings=` pull and
 * `auditId`/`supplierId` are handed straight to the datapoint-writer.
 */
export const AmforiDatapointsBatchAuditSchema = z.object({
  auditId: z.string().min(1),
  monitoringId: z.string().min(1),
  supplierId: z.string().min(1),
});

/**
 * Payload for a datapoints child batch job. Extends the base phase payload
 * (which carries the phase-group `correlationId` the master polls on — children
 * share it so the master waits for them too) with the batch's audit triples.
 */
export const AmforiDatapointsBatchPayloadSchema =
  AmforiPhaseJobPayloadSchema.extend({
    audits: z.array(AmforiDatapointsBatchAuditSchema).min(1),
  });

export type AmforiDatapointsBatchAudit = z.infer<
  typeof AmforiDatapointsBatchAuditSchema
>;
export type AmforiDatapointsBatchPayload = z.infer<
  typeof AmforiDatapointsBatchPayloadSchema
>;
